import { PersonOutline } from "@mui/icons-material";
import message from "../../../_i18n/fr.json";
import RealEstateAgent from "../../../ressources/images/RealEstateAgent";
import {
  DossierLocationItem,
  TypeParcours,
} from "../../../services/Api/swagger";
import { DossiersLocationProps } from "../../../services/Api/DossierLocation";
import { DEFAULT_NBR_ELEMENT_PAR_PAGE, Pagination } from ".";

export const getInfoTableau = (
  result: DossierLocationItem[],
  candidatLocataire?: boolean,
) => {
  return result.map((dos, i) => {
    const numero = (dos.bien && dos.bien.numero) || "";
    const adresse = (dos.bien && dos.bien.adresse) || "";
    const typeVoie = (dos.bien && dos.bien.typeVoie) || "";
    const loyer = (dos.bien && dos.bien.loyerMensuel) || 0;
    const charges = (dos.bien && dos.bien.chargesMensuelles) || 0;
    const typeParcours = dos.parcoursCandidatLocataire ? (
      <PersonOutline
        color={"secondary"}
        titleAccess="Candidat Locataire"
        fontSize="large"
      />
    ) : (
      <RealEstateAgent title="ADB" />
    );
    return {
      site: dos.site && dos.site.nom,
      refLocation: dos.reference,
      refMandat: dos.bien && dos.bien.referenceMandat,
      numeroLot: dos.bien && dos.bien.numeroLot,
      ville: dos.bien && dos.bien.ville,
      adresse: numero + " " + typeVoie + " " + adresse,
      loyerCharges: loyer + charges,
      loyerMaxConseille: dos.loyerMaxConseille,
      locReferent:
        dos.prenomLocataire &&
        dos.nomLocataire &&
        dos.prenomLocataire + " " + dos.nomLocataire,
      gli: dos.bien && dos.bien.garantieLi ? "Oui" : "Non",
      statut: dos.statut,
      type: candidatLocataire ? typeParcours : undefined,
      dateDemandeValidation: dos.dateDemandeValidation,
      locationAcceptee: dos.locationAcceptee,
      enCoursSuppression: dos.enCoursSuppression,
      dateCreation: dos.dateCreation,
    };
  });
};

export const construireListeStatuts = () => {
  return [
    "TOUS",
    "INCOMPLET",
    "A_VERIFIER",
    "VALIDE",
    "NON_VALIDE",
    "VALIDE_AGREE",
    "VALIDE_AGREE_DIFFERE",
    "VALIDE_NON_AGREE",
  ].map((s) => ({
    key: s,
    // @ts-ignore
    text: message.statutDossierLocation[s] || "Tous",
    value: s,
  }));
};

export const construireListeParcours = [
  {
    key: TypeParcours["ADB"],
    text: "Parcours ADB",
    value: TypeParcours["ADB"],
  },
  {
    key: TypeParcours["CANDIDAT_LOCATAIRE"],
    text: "Parcours Candidat locataire",
    value: TypeParcours["CANDIDAT_LOCATAIRE"],
  },
];

export const buildSearch = (
  criteres: DossiersLocationProps,
  resetPage: boolean,
  pagination: Pagination,
  idAdb?: number,
): DossiersLocationProps => {
  const adb = idAdb || criteres.adb;
  const page = resetPage ? 0 : pagination.page || 0;
  return {
    ...(adb ? { adb } : {}),
    ...(criteres.refDossier ? { refDossier: criteres.refDossier } : {}),
    ...(criteres.refMandat ? { refMandat: criteres.refMandat } : {}),
    ...(criteres.ville ? { ville: criteres.ville } : {}),
    ...(criteres.statut ? { statut: criteres.statut } : {}),
    ...(criteres.nomLocataire ? { nomLocataire: criteres.nomLocataire } : {}),
    ...(criteres.prenomLocataire
      ? { prenomLocataire: criteres.prenomLocataire }
      : {}),
    ...(criteres.gli ? { gli: criteres.gli } : {}),
    ...{ page },
    ...(pagination.nbrElementParPage
      ? { taille: pagination.nbrElementParPage }
      : { taille: DEFAULT_NBR_ELEMENT_PAR_PAGE }),
    ...(pagination.sortColumn
      ? {
          tri: `${pagination.sortColumn}:${pagination.sortOrder}`,
        }
      : {}),

    ...(criteres.typeParcours ? { typeParcours: criteres.typeParcours } : {}),
  };
};
